import React, { Component } from 'react';

import { SelectInput, SlButton, TextInput, SlBusyIndicator, SlMoneyInput, SlPageTitle, SlDropdown, SlFormEntryRow } from '../editors';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import validator from 'validator';
import { newLoanConstants } from "../../_constants";

import { registrationActions, newLoanActions } from "../../_actions";
import { metadataService, userService, ServiceUtil, workflowService, newLoanStepperService, newLoanService, SessionService } from "../../_services";
import Stepper from "./Stepper";
import { userActions } from '../../_actions/user.actions';
import infoIcon from '../images/infoIcon.svg';



class GetStarted extends Component {
    static displayName = GetStarted.name;

    constructor(props) {
        super(props);
        const { steps, currentStep } = props;
        this.state = {
            formValue: {
                firstName: this.props.firstName ? this.props.firstName : '',
                lastName: this.props.lastName ? this.props.lastName : '',
                email: this.props.email ? this.props.email : '',
                mobilePhone: this.props.mobileNumber ? this.props.mobileNumber : '',
                alternateMobilePhone: this.props.alternateMobilePhone ? this.props.alternateMobilePhone : '',
                city: this.props.city ? this.props.city : '',
                userState: this.props.userState ? this.props.userState : '',
                postalCode: this.props.postalCode ? this.props.postalCode : '',
                requestedAmount: this.props.requestedAmount ? this.props.requestedAmount : ''
            },
            steps: steps,
            currentStep: currentStep,
            PreApproved: false, PreApprovalCode: '',
            canMoveNext: false,
            isBusy: false,
            formError: true,
            fieldErrors: [],
            isStateSelectOpen: false,
            minLoanAmount: null,
            maxLoanAmount: null,
            preApprovalEnabled: false,
            showAlternatePhoneNumber: false,
            privacyPolicyUrl: '',
            nearbyBranches: true,
            doesBusinessInState: true,
        };

        this.state.formError = this.formHasError(this.state);
        this.handleInput = this.handleInput.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.formHasError = this.formHasError.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.openDropdown = this.openDropdown.bind(this);
    }

    async componentDidMount() {
        let workflowData = workflowService.getCurrentWorkflowStepData();

        if (!workflowData) {
            const { dispatch } = this.props;
            dispatch(registrationActions.handleNewLoanMenuClick());
            workflowData = workflowService.getCurrentWorkflowStepData();
        }

        if (workflowData) {
            let steps = newLoanStepperService(workflowData.workflowId);
            let currentStep = workflowData.currentStepperStep;

            let personalInfo = SessionService.getPersonalInfo();
            let newState = {};

            if (personalInfo) {
                newState = {
                    ...this.state,
                    steps: steps,
                    currentStep: currentStep,
                    formValue: {
                        firstName: personalInfo.firstName,
                        lastName: personalInfo.lastName,
                        email: personalInfo.email,
                        mobilePhone: personalInfo.mobileNumber,
                        alternateMobilePhone: personalInfo.alternateMobileNumber,
                        userState: personalInfo.userState,
                        requestedAmount: personalInfo.requestedAmount,
                        postalCode: personalInfo.postalCode
                    },
                    PreApprovalCode: personalInfo.preApprovalCode,
                    PreApproved: personalInfo.preApprovalCode ? true : false,
                    SocialSecurityNumber: personalInfo.socialSecurityNumber,
                    IndividualTaxIdentificationNumber: personalInfo.individualTaxIdentificationNumber,
                    DateOfBirth: personalInfo.dateOfBirth,
                    privacyPolicyUrl: await ServiceUtil.getServiceUrl("PrivacyPolicy"),
                    privacyPolicyUrlSpanish: await ServiceUtil.getServiceUrl("PrivacyPolicyEs"),
                    SMSUrl: await ServiceUtil.getServiceUrl("SMSUrl"),
                    SMSUrlEs: await ServiceUtil.getServiceUrl("SMSUrlEs")
                }
                this.handleChangeState(newState);
            }
            else {
                newState = {
                    ...this.state,
                    steps: steps,
                    currentStep: currentStep,
                    privacyPolicyUrl: await ServiceUtil.getServiceUrl("PrivacyPolicy"),
                    privacyPolicyUrlSpanish: await ServiceUtil.getServiceUrl("PrivacyPolicyEs"),
                    SMSUrl: await ServiceUtil.getServiceUrl("SMSUrl"),
                    SMSUrlEs: await ServiceUtil.getServiceUrl("SMSUrlEs")
                };
                this.handleChangeState(newState);
            }

            this.updateLoanAmounts(newState.formValue.userState);
        }
    }

    updateLoanAmounts = (userState, minAmount=null, maxAmount=null) => {
        if (userState === "") {
            this.handleChangeState({
                minLoanAmount: null,
                maxLoanAmount: null
            });
        }
        else if (minAmount != null && maxAmount != null) {
            this.handleChangeState({
                minLoanAmount: minAmount,
                maxLoanAmount: maxAmount
            });
        }
        else {
            newLoanService.validateState(userState).then(stateValidation => {
                let { doesBusinessInState, minLoanAmount, maxLoanAmount } = stateValidation.data;

                if (!doesBusinessInState) {
                    minLoanAmount = null;
                    maxLoanAmount = null;
                }
                this.handleChangeState({
                    minLoanAmount: minLoanAmount,
                    maxLoanAmount: maxLoanAmount
                });
            }).catch(err => {
                this.handleChangeState({
                    minLoanAmount: null,
                    maxLoanAmount: null
                });
            });
        }
    }

    handleInput = async ({ target: { name, value } }) => {
        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name === "LanguagePreference") {
            let currentStep = workflowService.getCurrentWorkflowStepData();
            newState.steps = newLoanStepperService(currentStep.workflowId);
        }

        if (name === "PostalCode" && value.length === 5) {
            metadataService.getCityStateByZip(value).then(async cityStateResponse => {
                if (cityStateResponse.data) {
                    let cityStateData = cityStateResponse.data;

                    this.handleChangeState({
                        formValue: {
                            ...this.state.formValue,
                            city: cityStateData.city,
                            userState: cityStateData.state
                        }
                    });

                    if (cityStateData.state === "") {
                        // We couldnt find the state, bypass loan amount validation
                        newState.doesBusinessInState = true;
                        newState.nearbyBranches = true;
                        this.updateLoanAmounts('');
                    } else {
                        let stateData = await newLoanService.validateState(cityStateData.state);

                        if (stateData == null || !stateData.data.doesBusinessInState) {
                            let nearbyBranches = await metadataService.getLocations(value, cityStateData.state, cityStateData.city);
                            if (nearbyBranches.data.branches.length > 0) {
                                newState.doesBusinessInState = false;
                                newState.nearbyBranches = true;
                            } else {
                                newState.doesBusinessInState = false;
                                newState.nearbyBranches = false;
                            }
                            this.updateLoanAmounts('');
                        } else {
                            newState.doesBusinessInState = true;
                            newState.nearbyBranches = true;
                            this.updateLoanAmounts(cityStateData.state, stateData.minLoanAmount, stateData.maxLoanAmount);
                        }
                    }
                }
                else {
                    newState.doesBusinessInState = false;
                    newState.nearbyBranches = false;
                    this.updateLoanAmounts('');
                }

                this.handleChangeState({ doesBusinessInState: newState.doesBusinessInState, nearbyBranches: newState.nearbyBranches });
            });
        }

        this.handleChangeState(newState);
    };

    handleBlur = ({ target: { name, value } }) => {

    };


    handleChangeState(newState) {
        let nextState = { ...newState };
        let checkState = { ...this.state, ...newState };

        nextState.formError = this.formHasError(checkState);
        nextState.fieldErrors = checkState.fieldErrors;

        this.setState(nextState)
    }

    handleValidation = () => {

        let formError = this.formHasError(this.state);
        this.setState((state, props) => {
            return {
                ...this.state,
                formError: formError
            };
        });

        return formError;

    };

    formHasError(stateData) {

        let firstNameError = false;
        let lastNameError = false;
        let emailError = false;
        let mobilePhoneError = false;
        //let userStateError = false;
        let alternateMobilePhoneError = false;
        let requestedAmountError = false;
        let postalCodeError = false;
        let fieldErrors = [];

        if (stateData.formValue.email) {
            if (stateData.formValue.email.length <= 5 || !metadataService.emailRegex(stateData.formValue.email) || !validator.isEmail(stateData.formValue.email)) {
                fieldErrors.push({ fieldName: "Email", messageName: "InvalidFormat" });
                emailError = true;
            }
        }

        if (stateData.formValue.mobilePhone) {
            if (stateData.formValue.mobilePhone.length < 10
                || !validator.isMobilePhone(stateData.formValue.mobilePhone + '', 'en-US')
                || metadataService.MobileNumberBeginsWithOneOrZero(stateData.formValue.mobilePhone)) {
                mobilePhoneError = true;
                fieldErrors.push({ fieldName: "MobilePhone", messageName: "MobilePhoneError" });
            }
        }
        if (stateData.formValue.alternateMobilePhone) {
            if (stateData.formValue.alternateMobilePhone.length < 10
                || !validator.isMobilePhone(stateData.formValue.alternateMobilePhone + '', 'en-US')
                || metadataService.MobileNumberBeginsWithOneOrZero(stateData.formValue.alternateMobilePhone)) {
                alternateMobilePhoneError = true;
                fieldErrors.push({ fieldName: "AlternateMobilePhone", messageName: "MobilePhoneError" });
            }
        }
        if (stateData.formValue.requestedAmount && !validator.isNumeric(stateData.formValue.requestedAmount + '')) {
            fieldErrors.push({ fieldName: "RequestedAmount", messageName: "InvalidFormat" });
            requestedAmountError = true;
        }

        if (stateData.formValue.requestedAmount
            && validator.isNumeric(stateData.formValue.requestedAmount + '')) {
            if (stateData.maxLoanAmount && parseFloat(stateData.formValue.requestedAmount) > stateData.maxLoanAmount) {
                fieldErrors.push({ fieldName: "RequestedAmount", messageName: "RequestedAmountMax", args: [stateData.maxLoanAmount] });
                requestedAmountError = true;
            }
            else if (stateData.minLoanAmount && parseFloat(stateData.formValue.requestedAmount) < stateData.minLoanAmount) {
                fieldErrors.push({ fieldName: "RequestedAmount", messageName: "RequestedAmountMin", args: [stateData.minLoanAmount] });
                requestedAmountError = true;
            }
            else if (parseFloat(stateData.formValue.requestedAmount) > parseFloat(newLoanConstants.MAX_REQUEST_AMOUNT)) {
                fieldErrors.push({ fieldName: "RequestedAmount", messageName: "RequestedAmountInvalid" });
                requestedAmountError = true;
            }
        }
        if (stateData.formValue.postalCode) {
            if (!stateData.doesBusinessInState && !stateData.nearbyBranches && stateData.formValue.postalCode.length === 5) {
                fieldErrors.push({ fieldName: "PostalCode", messageName: "NoBranchNearYou" });
                postalCodeError = true;
            } else if (stateData.formValue.postalCode.length !== 5) {
                fieldErrors.push({ fieldName: "PostalCode", messageName: "InvalidFormat" })
                postalCodeError = true;
            } else if (stateData.formValue.postalCode.length === 5 && !stateData.doesBusinessInState) {
                fieldErrors.push({ fieldName: "PostalCode", messageName: "InOffice" })
            }
        }

        stateData.fieldErrors = fieldErrors;

        if (validator.isEmpty(stateData.formValue.firstName + '') || validator.isEmpty(stateData.formValue.lastName + '')
            || validator.isEmpty(stateData.formValue.email + '') || validator.isEmpty(stateData.formValue.mobilePhone + '')
            || validator.isEmpty(stateData.formValue.state + '') || validator.isEmpty(stateData.formValue.requestedAmount + '') || validator.isEmpty(stateData.formValue.postalCode + '')) {

            return true;
        }
        firstNameError = validator.isEmpty(stateData.formValue.firstName + "");
        lastNameError = validator.isEmpty(stateData.formValue.lastName + "");
        emailError = (validator.isEmpty(stateData.formValue.email + "") || !validator.isEmail(stateData.formValue.email + ""));
        //userStateError = (validator.isEmpty(stateData.formValue.state + ""));
        requestedAmountError = (validator.isEmpty(stateData.formValue.requestedAmount + "") || requestedAmountError);
        let isBusy = stateData.isBusy;

        var hasError = ((firstNameError) || (lastNameError) || (emailError) || (mobilePhoneError) || (alternateMobilePhoneError) || (requestedAmountError) || (isBusy) || (postalCodeError));

        return hasError;
    }

    setMoveNext(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        let canMoveNext = this.handleValidation(newState);
        return { ...stateChanges, ...{ canMoveNext: canMoveNext, errorMessage: null } };
    }

    PreApprovalCodeClick = () => {
        const { dispatch } = this.props;
        dispatch(newLoanActions.preApproval());
    }

    getStartedClick = () => {
        const { dispatch } = this.props;
        return window.grecaptcha.ready(() => {
            ServiceUtil.getReCaptchaSiteKey().then(siteKey => {
                window.grecaptcha.execute(siteKey, { action: 'submit' }).then(token => {
                    ServiceUtil.verifyReCaptcha(token).then(verified => {

                        if (verified) {
                            this.SubmitData();
                        }
                        else {
                            dispatch(newLoanActions.sendToLoginReCaptchaFailed());
                        }
                    });
                });
            });
        });
    }

    SubmitData() {
        const { dispatch } = this.props;

        if (!this.formHasError(this.state)) {

            this.setState({ isBusy: true });

            userService.isEmailInUse(this.state.formValue.email.trim()).then(emailInUse => {
                if (emailInUse.data) {
                    dispatch(newLoanActions.sendToLoginEmailInUse());
                }
                else {
                    var newLoanRequest = {
                        "BranchId": this.props.branchId,
                        "BranchDetails": this.props.branchDetails,
                        "firstName": this.state.formValue.firstName,
                        "lastName": this.state.formValue.lastName,
                        "email": this.state.formValue.email.trim(),
                        "mobilePhone": this.state.formValue.mobilePhone,
                        "alternateMobilePhone": this.state.formValue.alternateMobilePhone,
                        "userState": this.state.formValue.userState,
                        "requestedAmount": this.state.formValue.requestedAmount,
                        "preApprovalCode": this.state.PreApprovalCode,
                        "socialSecurityNumber": this.state.SocialSecurityNumber,
                        "individualTaxIdentificationNumber": this.state.IndividualTaxIdentificationNumber,
                        "dateOfBirth": this.state.DateOfBirth,
                        "postalCode": this.state.formValue.postalCode,
                        "city": this.state.formValue.city,
                    };

                    dispatch(registrationActions.handleGetStartedInformationRequest(newLoanRequest));
                }

                this.setState({ isBusy: false });
            });
        }
    }

    openDropdown = () => {
        this.setState({ isStateSelectOpen: !this.state.isStateSelectOpen })
    }

    render() {
        let SMSUrl = userService.getUserLanguage().toLowerCase() === "es" ? this.state.SMSUrlEs : this.state.SMSUrl;
        return (
            <div className="GetStarted">
                {this.props.steps && this.props.steps.length > 0 && (
                    <Stepper stepData={this.props.steps} currentStep={this.state.currentStep} />
                )}
                {(
                    <div>
                        <div className="loggedOut">
                            <Card>
                                <CardBody>
                                    <SlFormEntryRow>
                                        <SlPageTitle pageName={"WelcomeToSunLoan"} />
                                        {this.props.disclosure.softHit ?
                                            <p className='text-center mt-3 pt-3 pr-3 pl-3'>{metadataService.getMessage('WelcomeToSunLoan')}<b>{metadataService.getMessage('WelcomeToSunLoan2')}</b>{metadataService.getMessage('WelcomeToSunLoan3')}</p>
                                            : <p className='text-center mt-3 pt-3 pr-3 pl-3'>{metadataService.getMessage('WelcomeToSunLoanNoSoftHit')}</p>
                                        }
                                    </SlFormEntryRow>
                                    {this.state.preApprovalEnabled === true && <Row>
                                        <Col sm={12} md={{ size: 8, offset: 2 }} >
                                            {!this.state.PreApproved && (
                                                <div className="text-center">
                                                    <p className='mb-0 pb-0 mt-3'>{metadataService.getLabel('PreApprovedSubText')}</p>
                                                    <p>{metadataService.getLabel('PreApprovedSubText2')}</p>
                                                    <SlButton name="PreApprovalCode" cssClass="backBtn" onClick={this.PreApprovalCodeClick} />
                                                </div>
                                            )}

                                            {this.state.PreApproved && (
                                                <div>
                                                    <h6 className="text-center">{metadataService.getLabel('YouEntered')}</h6>
                                                    <h3 className="text-center">{metadataService.getLabel('PreApprovalCode')} {this.state.PreApprovalCode}</h3>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>}
                                    <hr className="thinGrayLine" style={{ marginTop: "2em", marginBottom: "2em" }} />
                                    <Row className="CustomerInfo">
                                        <Col sm={12} md={{ size: 6, offset: 3 }} >
                                            <TextInput name="FirstName" value={this.state.formValue.firstName} onChange={this.handleInput} fieldErrors={this.state.fieldErrors} isRequired={true} maxLength={30} />
                                            <p className="left-text-font-small"><img src={infoIcon} className="infoIcon" />{metadataService.getMessage('AsShownOnID')}</p>
                                            <TextInput name='LastName' value={this.state.formValue.lastName} fieldErrors={this.state.fieldErrors} onChange={this.handleInput} isRequired={true} maxLength={30} />
                                            <p className="left-text-font-small"><img src={infoIcon} className="infoIcon" />{metadataService.getMessage('AsShownOnID')}</p>
                                            <TextInput name='Email' value={this.state.formValue.email} fieldErrors={this.state.fieldErrors} onChange={this.handleInput} isRequired={true} type='email' maxLength={256} />
                                            {userService.getUserLanguage().toLowerCase() === "en" &&
                                                <p className="left-text-font-small"><img src={infoIcon} className="infoIcon" />{metadataService.getMessage('ThisEmail')} <a href={this.state.privacyPolicyUrl} target="_new">{metadataService.getMessage('ThisEmail2')}</a>.</p>
                                            }
                                            {
                                                userService.getUserLanguage().toLowerCase() === "es" &&
                                                <p className="left-text-font-small"><img src={infoIcon} className="infoIcon" />{metadataService.getMessage('ThisEmail')} <a href={this.state.privacyPolicyUrlSpanish} target="_new">{metadataService.getMessage('ThisEmail2')}</a>.</p>
                                            }
                                            <TextInput name='MobilePhone' value={this.state.formValue.mobilePhone} onChange={this.handleInput} isRequired={true} fieldErrors={this.state.fieldErrors} type='number' maxLength={10} />
                                            <p className="left-text-font-small"><img src={infoIcon} className="infoIcon" />{metadataService.getMessage('CallOrText1')} <a href={SMSUrl} target='_new'>{metadataService.getMessage('CallOrText2')} </a>{metadataService.getMessage('CallOrText3')}.</p>
                                            {this.state.showAlternatePhoneNumber && <TextInput name='AlternateMobilePhone' value={this.state.formValue.alternateMobilePhone} onChange={this.handleInput} isRequired={false} fieldErrors={this.state.fieldErrors} type='number' maxLength={10} />}
                                            {/*<SlDropdown Name="State" value={this.state.formValue.state} handleChange={this.handleInput} options={metadataService.getLookup("state")} isRequired={true} open={this.state.isStateSelectOpen} openDropdown={this.openDropdown} />*/}
                                            <TextInput name='PostalCode' value={this.state.formValue.postalCode} onChange={this.handleInput} isRequired={true} fieldErrors={this.state.fieldErrors} type='number' maxLength={5} />
                                            <SlMoneyInput name='RequestedAmount' value={Number(this.state.formValue.requestedAmount)} fieldErrors={this.state.fieldErrors} onChange={this.handleInput} isRequired={true} placeholder='$' showLabel={true} />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <div className="text-center">
                            <SlBusyIndicator visible={this.state.isBusy} />
                            <SlButton name="GetStarted" size="lg" onClick={this.getStartedClick} disabled={this.state.formError || this.state.isBusy} />
                        </div>
                    </div>
                )}
                <hr></hr>
                {this.props.disclosure.softHit &&
                    <p className="center-text-font-small">{metadataService.getMessage("ForTheInitialPurpose")}</p>
                }

            </div>
        );
    }
}

function mapStateToProps(store) {
    const { firstName, lastName, email, mobileNumber, requestedAmount, state, preApprovalCode, preApproved, postalCode } = store.registration;
    const { steps, currentStep, disclosure } = store.users;
    const { loggedIn } = store.authentication;
    return {
        firstName, lastName, email, mobileNumber, requestedAmount, state, preApprovalCode, preApproved, loggedIn, steps, currentStep, disclosure, postalCode
    };
}

const connectedNewLoanApp = connect(mapStateToProps)(GetStarted);
export { connectedNewLoanApp as GetStarted };